var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 153,
    viewBox: "0 0 197 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H163V37H28.9064L0 0Z",
    fill: "#F9E11E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58H184V95H83.8447L55 58Z",
    fill: "#F9E11E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 116H197V153H132.615L104 116Z",
    fill: "#F9E11E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStats);
export default __webpack_public_path__ + "static/media/user-stats.8872ba3a4737d3776a11b7d62bb89a34.svg";
export { ForwardRef as ReactComponent };